import {forwardRef} from 'react'

import classNames from 'classnames/bind'

import Styles from './InsuranceDetailWrapper.module.scss'

import type {ReactNode} from 'react'

const cx = classNames.bind(Styles)

interface InsuranceDetailWrapperProps {
    children: ReactNode
    typeWhite?: boolean
    className?: string
    id?: string
}

const InsuranceDetailWrapper = forwardRef<HTMLDivElement, InsuranceDetailWrapperProps>(
    ({children, typeWhite, className, id}, ref?) => {
        return (
            <div ref={ref} id={id} className={cx('article', {'type-white': typeWhite}, className)}>
                {typeWhite ? <div className={cx('inner')}>{children}</div> : <>{children}</>}
            </div>
        )
    },
)

export default InsuranceDetailWrapper
